export const fields = (fields) => (request) => ({
    ...request,
    fields: {
        ...request.fields,
        ...fields,
    },
});
